import ProtectedRoute from 'components/ProtectedRoute'
import { Switch } from 'react-router-dom'
import { getCurrentEnvironment } from 'utilities/urlUtils'
import AISegmentBuilderPage from './AISegmentBuilder/AISegmentBuilderPage'
import ReviewItems from './AISegmentBuilder/ReviewItems'
import Landing from './Landing'
import SegmentPage from './SegmentPage'

const Segments = () => {
  const isNonProduction = getCurrentEnvironment() !== 'production'

  return (
    <Switch>
      {isNonProduction && (
        <ProtectedRoute
          exact
          path="/segments/ai-builder/review-items"
          component={ReviewItems}
          redirect="/segments"
          accessType="manage"
          resource="Segments"
        />
      )}
      <ProtectedRoute
        exact
        path="/segments/ai-builder"
        component={AISegmentBuilderPage}
        redirect="/segments"
        accessType="manage"
        resource="Segments"
      />
      <ProtectedRoute
        redirect="/"
        accessType="access"
        resource="Segments"
        exact
        path="/segments/:segmentId"
        component={SegmentPage}
      />
      <ProtectedRoute
        redirect="/"
        accessType="access"
        resource="Segments"
        exact
        path="/segments"
        component={Landing}
      />
    </Switch>
  )
}

export default Segments
